<template>
    <div>
        <div class="card my-3">
            <div class="card-header">班级证书管理</div>
            <div class="card-body" style="min-height: 600px">

                <div class="card" v-if="classCertificateData.classInfo">
                    <div class="card-header">班级信息</div>
                    <table class="table table-bordered mb-0">
                        <tbody>
                        <tr>
                            <th class="text-center align-middle" style="width: 10%">项目批次</th>
                            <td class="text-left align-middle" colspan="3">{{classCertificateData.classInfo.batchName}}</td>
                            <th class="text-center align-middle" style="width: 10%">财政年份</th>
                            <td class="text-left align-middle" style="width: 15%">{{classCertificateData.classInfo.fileYear}}</td>
                            <th class="text-center align-middle" style="width: 10%">实施年份</th>
                            <td class="text-left align-middle" style="width: 15%">{{classCertificateData.classInfo.implYear}}</td>
                        </tr>
                        <tr>
                            <th class="text-center align-middle" style="width: 10%">项目名称</th>
                            <td class="text-left align-middle" colspan="3">{{classCertificateData.classInfo.projectName}}</td>
                            <th class="text-center align-middle" style="width: 10%">总学时</th>
                            <td class="text-left align-middle" style="width: 15%">{{classCertificateData.classInfo.trainLength}}</td>
                            <th class="text-center align-middle" style="width: 10%">总学分</th>
                            <td class="text-left align-middle" style="width: 15%">{{classCertificateData.classInfo.trainScore}}</td>
                        </tr>
                        <tr>
                            <th class="text-center align-middle" style="width: 10%">班级名称</th>
                            <td class="text-left align-middle" colspan="3">{{classCertificateData.classInfo.className}}</td>
                            <th class="text-center align-middle" style="width: 10%">开始日期</th>
                            <td class="text-left align-middle" style="width: 15%">{{classCertificateData.classInfo.startDateString}}</td>
                            <th class="text-center align-middle" style="width: 10%">结束日期</th>
                            <td class="text-left align-middle" style="width: 15%">{{classCertificateData.classInfo.endDateString}}</td>
                        </tr>
                        <tr>
                            <th class="text-center align-middle" style="width: 10%">培训基地</th>
                            <td class="text-left align-middle" colspan="3">{{classCertificateData.classInfo.organName}}</td>
                            <th class="text-center align-middle" style="width: 10%">证书日期</th>
                            <td class="text-left align-middle" colspan="3">
                                <input type="date" class="form-control" v-model="certificateDate">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="card mt-3" v-if="classCertificateData.buildedCertificateData.length!==0">
                    <div class="card-header">已生成证书参训教师名单</div>
                    <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                            <th class="text-center align-middle" style="width: 5%">序号</th>
                            <th class="text-center align-middle" style="width: 10%">姓名</th>
                            <th class="text-center align-middle" style="width: 20%">身份证号</th>
                            <th class="text-center align-middle" style="width: 20%">所属院校</th>
                            <th class="text-center align-middle" style="width: 10%">级别</th>
                            <th class="text-center align-middle" style="width: 20%">证书编号</th>
                            <th class="text-center align-middle" style="width: 15%">操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(student, index) in classCertificateData.buildedCertificateData">
                            <td class="text-center align-middle">{{index+1}}</td>
                            <td class="text-center align-middle">{{student.studentName}}</td>
                            <td class="text-center align-middle">{{student.cardId}}</td>
                            <td class="text-left align-middle">{{student.collegeName}}</td>
                            <td class="text-center align-middle">{{student.scoreLevelName}}</td>
                            <td class="text-center align-middle">{{student.certificateId}}</td>
                            <td class="text-center align-middle">
                                <router-link class="btn btn-primary btn-sm mr-2" target="_blank" :to="{name: 'pdfView', params: {attFileId: student.attFileId}}">查看</router-link>
                                <a class="btn btn-primary btn-sm" :href="URL_DOWNLOAD + student.attFileId">下载</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="card-footer text-center">
                        <a class="btn btn-primary" :href="URL_CER_DOWNLOAD + classId">合并全部证书，并下载</a>
                    </div>
                </div>

                <div class="card mt-3" v-if="classCertificateData.notBuildedCertificateData.length!==0">
                    <div class="card-header">未生成证书参训教师名单</div>
                    <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                            <th class="text-center align-middle" style="width: 5%">序号</th>
                            <th class="text-center align-middle" style="width: 10%">姓名</th>
                            <th class="text-center align-middle" style="width: 20%">身份证号</th>
                            <th class="text-center align-middle" style="width: 20%">所属院校</th>
                            <th class="text-center align-middle" style="width: 10%">成绩</th>
                            <th class="text-center align-middle" style="width: 10%">级别</th>
                            <th class="text-center align-middle" style="width: 10%">图片</th>
                            <th class="text-center align-middle" style="width: 15%">操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(student, index) in classCertificateData.notBuildedCertificateData">
                            <td class="text-center align-middle">{{index+1}}</td>
                            <td class="text-center align-middle">{{student.studentName}}</td>
                            <td class="text-center align-middle">{{student.cardId}}</td>
                            <td class="text-left align-middle">{{student.collegeName}}</td>
                            <td class="text-center align-middle" :class="{'table-danger': !student.score}">{{student.score}}</td>
                            <td class="text-center align-middle" :class="{'table-danger': !student.scoreLevelName}">{{student.scoreLevelName}}</td>
                            <td class="text-center align-middle" :class="{'table-danger': !student.picture}">
<!--                                <img v-if="student.picture" :src="URL_ROOT + student.picture" style="width: 80px; height: 120px" alt="header">-->
                                {{student.picture? '有': '没有'}}
                            </td>
                            <td class="text-center align-middle">
                                <button class="btn btn-primary btn-sm" @click="btnBuildStudentCertificateInfo_Click(student.studentClassId)"
                                    :disabled="!student.score || !student.scoreLevelName ">生成证书</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="card-footer text-center">
                        <button class="btn btn-primary" @click="btnBuildAll_Click">生成全部证书</button>
                    </div>
                </div>

            </div>
        </div>

        <b-modal v-model="isLoadingDialogOpen"
                 title="系统消息" :hide-footer="true"
                 :no-close-on-backdrop="true">
            <div class="alert alert-warning mb-0">系统正在批量生成证书，请稍候</div>
        </b-modal>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import url from "@/utils/api/url";
export default {
    name: "OrganCertificateManage",
    data: function () {
        let now = new Date();
        let today = `${now.getFullYear()}-${now.getMonth()<9? '0'+(now.getMonth()+1): (now.getMonth()+1)}-${now.getDate()<10? '0'+now.getDate(): now.getDate()}`;

        return {
            URL_ROOT: url.URL_ROOT,
            URL_DOWNLOAD: url.URL_DOWNLOAD,
            URL_CER_DOWNLOAD: url.URL_CER_DOWNLOAD,

            classId: this.$route.params.classId,

            classCertificateData: {
                classInfo: null,
                classCertificateInfo: null,
                notBuildedCertificateData: [],
                buildedCertificateData: [],
            },

            certificateDate: today,

            studentCertificateInfo: {},
            isLoadingDialogOpen: false,
        };
    },
    mounted() {
        this.getClassCertificateData();
    },
    methods: {
        getClassCertificateData() {
            studyApi.certificate.getClassCertificateData(this.classId).then(res => {
                this.classCertificateData = res.data;
            });
        },

        btnBuildStudentCertificateInfo_Click(studentClassId) {
            let info = {studentClassId, createDate: this.certificateDate};
            studyApi.certificate.buildStudentCertificateInfo(info).then(res => {
                this.getClassCertificateData();
            });
        },

        btnBuildAll_Click() {
            let data = this.classCertificateData.notBuildedCertificateData.filter(item => {
                return item.picture && item.scoreLevelName;
            }).map(item => {
                return item.studentClassId;
            });
            console.log(data);

            this.isLoadingDialogOpen = true;
            let index = 0;
            this.buildAllCertificateItem(data, index);
        },
        buildAllCertificateItem(data, index) {
            let info = {
                studentClassId: data[index], createDate: this.certificateDate
            };
            studyApi.certificate.buildStudentCertificateInfo(info).then(res => {
                if (index < data.length - 1) {
                    index++;
                    this.buildAllCertificateItem(data, index);
                }
                else {
                    this.getClassCertificateData();
                    this.isLoadingDialogOpen = false;
                }
            });
        },

        btnMergeDownload_Click() {
            studyApi.certificate.mergeDown(this.classId).then(res => {

            });
        }
    }
}
</script>

<style scoped>
</style>